import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { dropDownFormStyle } from 'components/forms/new/formStyles';
import {
    formLabelStyling,
    stackStyling,
    stackSpacing,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const ZoomManagedByField = ({
    field,
    form,
    options,
    darkMode,
    disabled = false,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const error =
        form.errors.defaultManagedBy && form.touched.defaultManagedBy
            ? form.errors.defaultManagedBy
            : '';

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!error}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Default Managed By
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Default management setting for {form.values.name} users.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box
                        flex="1"
                        sx={{
                            paddingTop: '15px',
                        }}>
                        <VStack alignItems="normal" width="90%">
                            <Select
                                selectedOptionColor="brand"
                                {...field}
                                minWidth="410px"
                                width="100%"
                                height="auto"
                                placeholder="Select Default Managed By"
                                value={
                                    options.find(
                                        (opt) =>
                                            opt.value ===
                                            form.values.defaultManagedBy,
                                    ) || null
                                }
                                onChange={(e) =>
                                    form.setFieldValue(
                                        'defaultManagedBy',
                                        e.value,
                                    )
                                }
                                options={options}
                                getOptionLabel={(option) => option.name}
                                isDisabled={disabled}
                                chakraStyles={dropDownFormStyle(darkMode)}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                    }),
                                }}
                            />
                            {error && (
                                <Text
                                    color="red.500"
                                    fontSize="xs"
                                    mt={1}
                                    textAlign="right">
                                    {error}
                                </Text>
                            )}
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Default management setting for Zoom users."
                        ariaLabel="zoom-managed-by-tip"
                        right="20px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ZoomManagedByField;
